import { Link } from 'react-router-dom';

import { Alert } from '@/components/ui';

import { PLAN_PATH } from './plans';

/**
 * Shown when an allowance on the free plan is used up. The sentence comes
 * from the API where it has one (`upgrade_hint`), so the number in it is the
 * number actually enforced.
 */
export function UpgradeNotice({ title = 'Monthly limit reached', children, className }) {
  return (
    <Alert tone="info" title={title} className={className}>
      <p>{children}</p>
      <Link
        to={PLAN_PATH}
        className="text-brand-700 hover:text-brand-800 mt-2 inline-block font-medium underline underline-offset-2"
      >
        See Premium
      </Link>
    </Alert>
  );
}
